//
import {
  Card,
  CardContent,
  CardMedia,
  Container,
  Grid,
  ListItem,
  ListItemText,
  TextField,
} from "@mui/material";
import MDBox from "components/MDBox";
import styled from "@emotion/styled";
import MDTypography from "components/MDTypography";
import * as React from "react";
import ArrowOutwardIcon from "@mui/icons-material/ArrowOutward";

import Group7 from "assets/images/home-page-images/Group7.png";
import client_customer from "assets/images/home-page-images/client_customer_profile_hand_personalized.png";
import client_customer1 from "assets/images/home-page-images/13-128.png";
import client_customer2 from "assets/images/home-page-images/cyborg-technology-ai-android-program-control-setting-growth_mindset.png";
import client_customer3 from "assets/images/home-page-images/36864901.png";
import image3 from "assets/images/home-page-images/image3.png";
import image6 from "assets/images/home-page-images/image6.png";
import image7 from "assets/images/home-page-images/image7.png";
import image8 from "assets/images/home-page-images/image8.png";
import Group from "assets/images/home-page-images/Group.png";
import image11 from "assets/images/home-page-images/image11.png";
import composeAdorn from "assets/images/home-page-images/compose-adorn-shadow.png";
import Contact from "assets/images/home-page-images/21742836_6491956.png";
import Rectangle18 from "assets/images/home-page-images/Rectangle18.png";
import Rectangle19 from "assets/images/home-page-images/Rectangle19.png";
import Rectangle20 from "assets/images/home-page-images/Rectangle20.png";
import Rectangle35 from "assets/images/home-page-images/Rectangle35.png";
import Rectangle33 from "assets/images/home-page-images/Rectangle33.png";
import Group54 from "assets/images/home-page-images/Group54.png";
// import Group57 from "assets/images/home-page-images/Group57.png";
import Group57 from "assets/images/home-page-images/Group182.png";
import Rectangle73 from "assets/images/home-page-images/Landingcard.png";
import review from "assets/images/home-page-images/carbon_review.png";
import locations from "assets/images/home-page-images/tdesign_location.png";
import fluent_arrow from "assets/images/home-page-images/fluent_arrow.png";
import Momemt from "assets/images/home-page-images/Momemt.png";
import UserMob from "assets/images/home-page-images/Mob.png";
import MobGradient from "assets/images/home-page-images/MobGradient.png";
import MobLocalI from "assets/images/home-page-images/MobLocalI.png";
import MobLocalII from "assets/images/home-page-images/MObLocalII.png";
import MobCutt from "assets/images/home-page-images/MobCutt.png";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import Blog2 from "assets/images/home-page-images/Blog2.png";
import Blog3 from "assets/images/home-page-images/Blog3.png";
//list
import List from "@mui/material/List";
import zIndex from "@mui/material/styles/zIndex";
import MDButton from "components/MDButton";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";
import { ArrowBackIos, ArrowForwardIos } from "@mui/icons-material";
import Testimonials from "./Testimonials";
import MDInput from "components/MDInput";
import DemoRequestForm from "./DemoRequestForm";
import { NavLink } from "react-router-dom";
//styled components
const StyledListItem = styled.li`
  border-left: 4px solid #318bec;
  background-color: #ffffff;
  box-shadow: 0px 16px 50px 0px #b9c0c933;
  padding-top: 0.9rem;
  padding-bottom: 0.9rem;
  margin-bottom: 17px;
  padding-left: 1rem;
  padding-right: 1rem;
  width: "100%";
`;
const StyledListText = styled.p`
  font-size: 18px;
  font-weight: 500;
  line-height: 30px;
  color: #6b6b6b;
`;
const StyledSectionHeading1 = styled.h2`
@media only screen and (min-width: 580px){
  font-size: 42px;
  line-height: 50px;
},
font-size:25px;
font-weight: 700;
  line-height: 32px;
  text-align: left;
  color: #318bec;
   margin-bottom:2rem;

`;
const StyledSectionHeading2 = styled.span`
@media only screen and (min-width: 580px){
  font-size: 42px;
  line-height: 50px;
  
},
 font-size:25px;
  font-weight: 700;
  line-height: 32px;
  text-align: left;
  color: #292929;
  padding-left:0.7rem
 
`;

const StyledListTextColor = styled.p`
  font-size: 24px;
  font-weight: 700;
  line-height: 30px;
  color: #318bec;
`;

const items = [
  "Use AI to automatically generate personalized responses, monitor brand sentiment, and catch negative reviews.",
  "Boost 5-star ratings effortlessly by encouraging happy customers to leave reviews via text, email, and QR codes.",
  "No guesswork. Just real-time reputation management, built for restaurants and bars. ",
];

const itemOne = [
  "Identify unmet demand like vegan, late-night, or healthy meal options within a 3-mile radius.",
  "Plan staffing, inventory, and promotions using event calendars, holidays, and forecasts.",
  "Analyze peak times by day and hour to fine-tune hours, ads, and service offerings",
  "Use “Compare Me” to see how you stack up against local competitors on price, ratings, and menu features.",
];
const itemTwo = [
  "TavloAI analyzes reviews, listings, and social media to deliver powerful, real-time insights—customized to help you make smarter decisions and accelerate growth.",
  "Tailor promotions based on local audience preferences",
  "Optimize menu, hours, and services using real-time demand signals",
];
const itemThree = [
  " Send personalized offers and messages",
  "Boost repeat visits and group bookings",
  "Build lasting loyalty with thoughtful, timely outreach",
];
const itemFour = [
  "Social Media Management & Post Design",
  "Yelp and Google Business Profile Optimization",
  "Campaigns Around Local Events and Guest Milestones ",
  "Direct Outreach to New Customers Nearby",
];

const cards = [
  {
    image: Rectangle18,
    title: "Heading 1",
    description:
      "Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC,",
  },
  {
    image: Rectangle19,
    title: "Heading 2",
    description:
      "Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC,",
  },
  {
    image: Rectangle20,
    title: "Heading 3",
    description:
      "Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC,",
  },
];

const counters = [
  { value: "97.4%", label: "Satisfaction Rate" },
  { value: "50%", label: "Faster Review Responses" },
  { value: "20%", label: "More Revenue" },
];

const cardList = [
  {
     link: "/insightContent",
    image: Rectangle73,
    heading: "Restaurant Marketing",
    title: "10 AI Restaurant Marketing Strategies in 2025",
    description:
      "The marketing world moves fast, especially in the restaurant industry. New apps, social trends, and tech tools seem to appear every month.",
    date: "24th July, 2025",
  },
  {
      image: Blog2,
      heading: "Latest",
      title: "AI in Restaurant Marketing: What You Need to Know",
      description: "Restaurant marketing has changed a lot over the past decade. Flyers, radio spots, and word-of-mouth still matter, but in 2026, artificial intelligence (AI).",
      date: "August 12, 2025",
      link: "/customer",
    },
    {
      image: Blog3,
      heading: "Trending",
      title: "Why Your Restaurant Needs an AI Review Assistant in 2026",
      description: "In 2026, your restaurant’s online reputation is crucial. A single review can influence many potential customers.",
      date: "August 13, 2025",
      link: "/operational",
    },
];

function BodySection() {
  const [showButton, setShowButton] = React.useState(false);
  const [bottomOffset, setBottomOffset] = React.useState(20);
  console.log(bottomOffset, "bottom ");
  // Track scroll position
  React.useEffect(() => {
    const handleScroll = () => {
      const scrollY = window.scrollY;
      const windowHeight = window.innerHeight;
      const documentHeight = document.documentElement.scrollHeight;
      const isMobile = window.matchMedia("(max-width: 768px)").matches;
      const mobileBottomOffset = 395;
      const desktopBottomOffset = 320;

      setShowButton(scrollY > 500);

      if (windowHeight + scrollY >= documentHeight - 100) {
        setBottomOffset(isMobile ? mobileBottomOffset : desktopBottomOffset);
      } else {
        setBottomOffset(20);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };
  return (
    <MDBox
      sx={{
        position: "relative",
        width: "100%",
        maxWidth: {
          xs: "100%",
          md: "1580px",
          xl: "1920px",
        },
        mx: "auto",
        // px: 2,
      }}
    >
      <MDBox
        sx={{
          // width: "100%",
          // margin: "auto",
          py: {
            xs: 2,
            sm: 2,
            md: 4,
          },
          mt: 6,
          mb: {
            xs: 0,
            sm: 2,
            md: 4,
          },
          zIndex: 2,
          boxShadow: {
            xs: "none",
            sm: "0px 4px 25px 6px #0000004D",
            md: "0px 4px 25px 6px #0000004D",
          },
        }}
      >
        <MDBox sx={{ width: "94.5%", margin: "auto" }}>
          <MDBox sx={{ zIndex: 2, mb: { xs: 3, sm: 10, md: 10 } }}>
            <MDTypography
              sx={{
                fontWeight: "700",
                fontSize: {
                  xs: "20px",
                  sm: "40px",
                  md: "40px",
                },
                width: "100%",
                textAlign: "center",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontFamily: "Poppins",
                color: "#000",
              }}
            >
              Tavlo{" "}
              <MDTypography
                component="span"
                sx={{
                  fontWeight: "700",
                  fontSize: {
                    xs: "20px",
                    sm: "40px",
                    md: "40px",
                  },
                  color: "#337BFF",
                  fontFamily: "Poppins",
                  mr: 1,
                }}
              >
                AI{" "}
              </MDTypography>
              Solutions
            </MDTypography>
          </MDBox>
          <MDBox
            sx={{
              zIndex: 2,
              display: "flex",
              gap: {
                xs: 3,
                sm: 4,
              },
              justifyContent: "center",
              alignItems: "start",
              flexDirection: {
                xs: "column",
                sm: "row",
              },
              mb: 6,
            }}
          >
            {/* First Card */}
            <Card
              sx={{
                position: "relative",
                width: {
                  xs: "340px",
                  sm: "340px",
                },
                margin: "auto",
                height: {
                  xs: "auto",
                  sm: "180px",
                  md: "280px",
                },
                boxShadow: 3,
                borderRadius: 4,
                color: "#fff",
                background: "#337BFF",
                // boxShadow: "1px 2px 4px 1px #5151518c",

                boxShadow: "1px 2px 4px 1px #5151518c",
              }}
            >
              <CardContent sx={{ textAlign: "center" }}>
                <MDBox mb={1}>
                  <MDBox
                    sx={{
                      display: {
                        xs: "none",
                        sm: "flex",
                        md: "flex",
                      },
                      position: "absolute",
                      top: -46,
                      left: "50%",
                      transform: "translateX(-50%)",
                      width: 80,
                      height: 80,
                      overflow: "hidden",
                    }}
                  >
                    <img
                      src={client_customer3}
                      alt="tick icon"
                      style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                      }}
                    />
                  </MDBox>{" "}
                  <MDBox
                    sx={{
                      display: {
                        xs: "flex",
                        sm: "block",
                      },
                      gap: 1,
                      alignItems: "center",
                      justifyContent: "center",
                      textAlign: "center",
                      mt: {
                        xs: 0,
                        sm: 2,
                        md: 8,
                      },
                    }}
                  >
                    <MDBox
                      sx={{
                        display: {
                          xs: "inline-flex",
                          sm: "none",
                          md: "none",
                        },
                        gap: 2,
                        justifyContent: "center",
                        alignItems: "center",
                        textAlign: "center",
                        pt: { xs: 1, sm: 0, md: 0 },
                      }}
                    >
                      <img
                        src={review}
                        style={{ width: "28px", height: "28px" }}
                        alt="review icon"
                      />
                    </MDBox>

                    <MDTypography
                      variant="h6"
                      sx={{
                        color: "#fff",
                        fontWeight: 600,
                        fontSize: "20px",
                        fontFamily: "Poppins",
                        textAlign: "center",
                        pt: { xs: 1, sm: 0, md: 0 },
                      }}
                    >
                      Review intelligence
                    </MDTypography>
                  </MDBox>
                </MDBox>
                <MDTypography
                  variant="body2"
                  color="text.secondary"
                  sx={{
                    fontFamily: "Poppins",
                    fontSize: { xs: "13px", sm: "14px", md: "14px" },
                    textAlign: "center",
                  }}
                >
                  Automatically analyze and reply to reviews,improve reputation,
                  boost local SEO, and build customer trust effortlessly.
                </MDTypography>
              </CardContent>
            </Card>

            {/* Second Card */}

            <Card
              sx={{
                position: "relative",
                width: {
                  xs: "340px",
                  sm: "340px",
                },
                margin: "auto",
                height: {
                  xs: "auto",
                  sm: "180px",
                  md: "280px",
                },
                boxShadow: 3,
                borderRadius: 4,
                background: "#337BFF",
                boxShadow: "1px 2px 4px 1px #5151518c",
                color: "#fff",
              }}
            >
              <CardContent sx={{ textAlign: "center" }}>
                <MDBox mb={1}>
                  <MDBox
                    sx={{
                      display: {
                        xs: "none",
                        sm: "flex",
                        md: "flex",
                      },
                      position: "absolute",
                      top: -48,
                      left: "50%",
                      transform: "translateX(-50%)",
                      width: 80,
                      height: 80,
                      overflow: "hidden",
                    }}
                  >
                    <img
                      src={client_customer1}
                      alt="tick icon"
                      style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                      }}
                    />
                  </MDBox>{" "}
                  <MDBox
                    sx={{
                      display: {
                        xs: "flex",
                        sm: "block",
                      },
                      alignItems: "center",
                      justifyContent: "center",
                      textAlign: "center",
                      mt: {
                        xs: 0,
                        sm: 2,
                        md: 8,
                      },
                    }}
                  >
                    <MDBox
                      sx={{
                        display: {
                          xs: "flex",
                          sm: "block",
                        },
                        gap: 1,
                        alignItems: "center",
                        justifyContent: "center",
                        textAlign: "center",
                        mt: {
                          xs: 0,
                          sm: 2,
                          md: 8,
                        },
                      }}
                    >
                      <MDBox
                        sx={{
                          display: {
                            xs: "inline-flex",
                            sm: "none",
                            md: "none",
                          },
                          gap: 2,
                          justifyContent: "center",
                          alignItems: "center",
                          textAlign: "center",
                          pt: { xs: 1, sm: 0, md: 0 },
                        }}
                      >
                        <img
                          src={locations}
                          style={{ width: "28px", height: "28px" }}
                          alt="review icon"
                        />
                      </MDBox>

                      <MDTypography
                        variant="h6"
                        sx={{
                          color: "#fff",
                          fontWeight: 600,
                          fontSize: "20px",
                          fontFamily: "Poppins",
                          textAlign: "center",
                          pt: { xs: 1, sm: 0, md: 0 },
                        }}
                      >
                        Local Intelligence
                      </MDTypography>
                    </MDBox>
                  </MDBox>
                </MDBox>
                <MDTypography
                  variant="body2"
                  color="text.secondary"
                  sx={{
                    fontFamily: "Poppins",
                    fontSize: { xs: "13px", sm: "14px", md: "14px" },
                    textAlign: "center",
                  }}
                >
                  Track competitors and local trends to discover winning
                  strategies and stay ahead in your neighborhood.
                </MDTypography>
              </CardContent>
            </Card>

            {/* third Card */}

            <Card
              sx={{
                position: "relative",
                width: {
                  xs: "340px",
                  sm: "340px",
                },
                margin: "auto",
                height: {
                  xs: "142px",
                  sm: "180px",
                  md: "280px",
                },
                boxShadow: 3,
                borderRadius: 4,
                background: "#337BFF",
                boxShadow: "1px 2px 4px 1px #5151518c",
                color: "#fff",
              }}
            >
              <CardContent sx={{ textAlign: "center" }}>
                <MDBox mb={1}>
                  <MDBox
                    sx={{
                      display: {
                        xs: "none",
                        sm: "flex",
                        md: "flex",
                      },
                      position: "absolute",
                      top: -46,
                      left: "50%",
                      transform: "translateX(-50%)",
                      width: 80,
                      height: 80,
                      overflow: "hidden",
                    }}
                  >
                    <img
                      src={client_customer2}
                      alt="tick icon"
                      style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                      }}
                    />
                  </MDBox>
                  <MDBox
                    sx={{
                      display: {
                        xs: "flex",
                        sm: "block",
                      },
                      gap: 1,
                      alignItems: "center",
                      justifyContent: "center",
                      textAlign: "center",
                      mt: {
                        xs: 0,
                        sm: 2,
                        md: 8,
                      },
                    }}
                  >
                    <MDBox
                      sx={{
                        display: {
                          xs: "inline-flex",
                          sm: "none",
                          md: "none",
                        },
                        gap: 2,
                        justifyContent: "center",
                        alignItems: "center",
                        textAlign: "center",
                        pt: { xs: 1, sm: 0, md: 0 },
                      }}
                    >
                      <img
                        src={fluent_arrow}
                        style={{ width: "28px", height: "28px" }}
                        alt="location icon"
                      />
                    </MDBox>

                    <MDTypography
                      variant="h6"
                      sx={{
                        color: "#fff",
                        fontWeight: 600,
                        fontSize: "20px",
                        fontFamily: "Poppins",
                        textAlign: "center",
                        pt: { xs: 1, sm: 0, md: 0 },
                      }}
                    >
                      Growth Intelligence
                    </MDTypography>
                  </MDBox>
                </MDBox>
                <MDTypography
                  variant="body2"
                  color="text.secondary"
                  sx={{
                    fontFamily: "Poppins",
                    fontSize: { xs: "13px", sm: "14px", md: "14px" },
                    textAlign: "center",
                  }}
                >
                  Unlock data-backed insights and 90-day strategies to increase
                  customers, sales, and sustainable business growth.
                </MDTypography>
              </CardContent>
            </Card>
            {/* Fouth Card */}

            <Card
              sx={{
                position: "relative",
                width: {
                  xs: "340px",
                  sm: "340px",
                },
                margin: "auto",
                height: {
                  xs: "190px",
                  sm: "180px",
                  md: "280px",
                },
                boxShadow: 3,
                borderRadius: 4,
                background: "#337BFF",
                boxShadow: "1px 2px 4px 1px #5151518c",
                color: "#fff",
              }}
            >
              <CardContent sx={{ textAlign: "center" }}>
                <MDBox mb={1}>
                  <MDBox
                    sx={{
                      display: {
                        xs: "none",
                        sm: "flex",
                        md: "flex",
                      },
                      position: "absolute",
                      top: -45,
                      left: "50%",
                      transform: "translateX(-50%)",
                      width: 80,
                      height: 80,
                      overflow: "hidden",
                    }}
                  >
                    <img
                      src={client_customer}
                      alt="tick icon"
                      style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                      }}
                    />
                  </MDBox>{" "}
                  <MDBox
                    sx={{
                      display: {
                        xs: "flex",
                        sm: "block",
                      },
                      gap: 1,
                      alignItems: "center",
                      justifyContent: "center",
                      textAlign: "center",
                      mt: {
                        xs: 0,
                        sm: 2,
                        md: 8,
                      },
                    }}
                  >
                    <MDBox
                      sx={{
                        display: {
                          xs: "inline-flex",
                          sm: "none",
                          md: "none",
                        },
                        gap: 2,
                        justifyContent: "center",
                        alignItems: "center",
                        textAlign: "center",
                        pt: { xs: 1, sm: 0, md: 0 },
                      }}
                    >
                      <img
                        src={Momemt}
                        style={{ width: "28px", height: "28px" }}
                        alt="review icon"
                      />
                    </MDBox>

                    <MDTypography
                      variant="h6"
                      sx={{
                        color: "#fff",
                        fontWeight: 600,
                        fontSize: "20px",
                        fontFamily: "Poppins",
                        textAlign: "center",
                        pt: { xs: 1, sm: 0, md: 0 },
                      }}
                    >
                      Tavlo Moments
                    </MDTypography>
                  </MDBox>
                </MDBox>
                <MDTypography
                  variant="body2"
                  color="text.secondary"
                  sx={{
                    height: "155px",
                    overflow: "hidden",
                    fontFamily: "Poppins",
                    fontSize: { xs: "13px", sm: "14px", md: "14px" },
                    textAlign: "center",
                  }}
                >
                  AI-powered outreach that identifies potential customers with
                  upcoming birthdays, anniversaries, and milestones—so you can
                  turn celebrations into loyal relationships with well-timed,
                  compelling offers.
                </MDTypography>
              </CardContent>
            </Card>
          </MDBox>
        </MDBox>
      </MDBox>
      {/* First */}
      <Grid
        container
        sx={{
          display: "flex",
          alignItems: {
            xs: "start",
            sm: "center",
            md: "center",
          },
          justifyContent: "space-between",
          pb: 0,
          mb: 0,
          mt: 0,
          pt: {
            xs: 0,
            sm: 3,
            md: 4,
          },
        }}
      >
        <MDBox
          sx={{
            width: "95%",
            margin: "end",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",

            "@media (min-width:1580px)": { maxWidth: "1600px!important" },
          }}
        >
          <Grid
            item
            xs={4}
            lg={7}
            sx={{
              position: "relative",
              width: "100%", // ensure full width on small screens
              display: "flex",
              justifyContent: {
                xs: "start",
                sm: "center",
                md: "flex-start",
              },
              alignItems: "center",
              flexDirection: "column", // stack for mobile
            }}
          >
            {/* Background Box */}
            <MDBox
              sx={{
                display: { xs: "none", sm: "block", md: "block" },
                // border: "1px solid red",
                width: {
                  xs: "126px", // mobile
                  sm: "85%",
                  md: "80%",
                },
                height: {
                  xs: "278px",
                  sm: "300px",
                  md: "567px",
                },
                transform: "rotate(0deg)",
                opacity: 1,
                marginLeft: {
                  xs: "-610px",
                  md: "-530px",
                },
                mt: {
                  xs: 0,
                  sm: 0,
                  md: 0,
                },
                pr: 100,
                borderRadius: "15px",
                background: "linear-gradient(90deg, #FFFFFF 25%, #FF981B 100%)",
              }}
            />
            <MDBox
              component="img"
              src={MobGradient}
              alt="Woman using a laptop"
              sx={{
                display: { xs: "block", sm: "none", md: "none" },
                width: {
                  xs: "136px", // mobile
                  sm: "85%",
                  md: "80%",
                },
                height: {
                  xs: "278px",
                  sm: "300px",
                  md: "567px",
                },
                maxWidth: "100%",
                borderRadius: { xs: "0px", sm: "20px", md: "20px" },
              }}
            />

            {/* Image */}
            <MDBox
              sx={{
                position: {
                  xs: "relative",
                  md: "absolute",
                },
                top: {
                  xs: -50,
                  md: 75,
                },
                right: {
                  xs: 10,
                  md: -40,
                },
                mt: {
                  xs: "-200px",
                  sm: "-230px",
                  md: 0,
                },
                pr: {
                  xs: 0,
                  md: "4rem",
                },
                display: "flex",
                justifyContent: "center",
              }}
            >
              <MDBox
                component="img"
                src={image3}
                alt="Woman using a laptop"
                sx={{
                  display: { xs: "none", sm: "block", md: "block" },
                  width: {
                    xs: "118px",
                    sm: "100%",
                    md: "100%",
                  },
                  maxWidth: "100%",
                  borderRadius: "20px",
                  height: {
                    xs: "224px", // Mobile height
                    sm: "260px", // Tablet height
                    md: "345px", // Desktop height
                  },
                }}
              />
              <MDBox
                component="img"
                src={UserMob}
                alt="Woman using a laptop"
                sx={{
                  display: { xs: "block", sm: "none", md: "none" },
                  width: {
                    xs: "118px",
                    sm: "100%",
                    md: "100%",
                  },
                  maxWidth: "100%",
                  borderRadius: { xs: "0px", sm: "20px", md: "20px" },
                  height: {
                    xs: "224px", // Mobile height
                    sm: "260px", // Tablet height
                    md: "345px", // Desktop height
                  },
                }}
              />
            </MDBox>
          </Grid>

          <Grid item xs={8} lg={5} sx={{ width: "100%", ml: 2 }}>
            <MDBox
              sx={{
                display: "flex",
                alignItems: "start",
                justifyContent: "center",
                flexDirection: "column",
                height: "100%",
                mt: {
                  xs: 0,
                  sm: 0,
                  md: -7,
                },
                pl: {
                  xs: 0,
                },
                "@media(min-width:576px)": { marginBottom: "0px" },
              }}
            >
              <MDTypography
                sx={{
                  fontWeight: "600",
                  fontSize: {
                    xs: "12px",
                    sm: "20px",
                    md: "24px",
                  },
                  width: "100%",
                  color: "#000",
                  fontFamily: "Poppins",
                  mb: {
                    xs: 0.5,
                    sm: 2,
                    md: 2,
                  },
                }}
              >
                {" "}
                AI-Powered Review Management
              </MDTypography>
              <MDTypography
                sx={{
                  fontWeight: 400,
                  fontSize: "18px",
                  width: "100%",
                  color: "#000",
                  fontFamily: "Poppins",
                  fontSize: {
                    xs: "10px",
                    sm: "14px",
                    md: "16px",
                  },
                  lineHeight: {
                    xs: 1.5,
                    sm: 2.2,
                    md: 2.2,
                  },
                  mb: {
                    xs: 0,
                    sm: 1,
                    md: 1,
                  },
                }}
              >
                {" "}
                TavloAI consolidates all your reviews from Google, Yelp,
                Facebook, and Instagram into a single, smart dashboard.
              </MDTypography>

              <List>
                {items.map((item, index) => (
                  <ListItem key={index} disableGutters alignItems="flex-start">
                    <MDBox
                      sx={{
                        marginLeft: { xs: "6px", sm: "15px", md: "15px" },
                        fontSize: { xs: "5px", sm: "6px", md: "6px" },
                        mr: 1,
                        lineHeight: 2.2,
                        mt: {
                          xs: "5px",
                          sm: "10px",
                          md: "15px",
                        },
                      }}
                    >
                      <FiberManualRecordIcon sx={{ color: "#000" }} />
                    </MDBox>
                    <ListItemText
                      primary={item}
                      primaryTypographyProps={{
                        sx: {
                          fontFamily: "urbanist",
                          fontWeight: 400,
                          fontSize: {
                            xs: "10px",
                            sm: "14px",
                            md: "16px",
                          },
                          color: "#000",
                          fontFamily: "Poppins",
                          lineHeight: {
                            xs: "18px",
                            sm: 2.2,
                            md: 2.2,
                          },
                        },
                      }}
                    />
                  </ListItem>
                ))}
              </List>
              <MDBox
                sx={{
                  display: "flex",
                  justifyContent: "flex-start",
                  width: "100%",
                  mt: {
                    xs: 0.5,
                    sm: 1,
                    md: 3,
                  },
                }}
              >
                <MDBox
                  component={NavLink}
                  to="/sign-up"
                  color="black"
                  sx={{
                    color: "#fff",
                    backgroundColor: "#000",
                    height: { xs: "29px", sm: "auto", md: "auto" },
                    padding: {
                      xs: "0px 20px",
                      sm: "12px 48px",
                      md: "20px 48px",
                    },
                    borderRadius: {
                      xs: "7px",
                      sm: "10px",
                      md: "10px",
                    },
                    fontSize: {
                      xs: "12px",
                      sm: "14px",
                      md: "15px",
                    },
                    fontWeight: 600,
                    lineHeight: {
                      xs: "30px",
                      sm: 0.6,
                      md: 0.6,
                    },
                    fontFamily: "Poppins",
                    textTransform: "none",
                    textTransform: "captialise",
                    "&:hover": {
                      backgroundColor: "#333",
                    },
                  }}
                >
                  Try Now
                </MDBox>
              </MDBox>
            </MDBox>
          </Grid>
        </MDBox>
      </Grid>
      {/* Second */}
      <Grid
        container
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          pb: 0,
          mb: 0,
          mt: 0,
          width: "100%",
          "@media(min-width:1024px)": { pb: 5, mb: 3 },
          "@media(min-width:1900px)": { paddingTop: "4rem", mt: 2, mb: 0 },
        }}
      >
        <MDBox
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",

            width: "92%",
            margin: "auto",
          }}
        >
          <Grid
            item
            xs={8}
            lg={6}
            sx={{
              width: {
                xs: "100%",
                sm: "60%",
              },
            }}
          >
            <MDBox
              sx={{
                pl: {
                  xs: 0,
                  sm: 1,
                  md: 2,
                },
                width: { xs: "100%", sm: "90%", md: "90%" },
                display: "flex",
                alignItems: "start",
                justifyContent: "center",
                flexDirection: "column",
                height: "100%",
                mt: {
                  xs: 0,
                  sm: 4,
                  md: 0,
                },
                // "@media(min-width:320px)": {
                //   marginTop: "105px",
                //   marginBottom: "26px",
                // },
                "@media(min-width:576px)": { marginBottom: "0px" },
              }}
            >
              <MDTypography
                sx={{
                  fontWeight: "600",
                  fontSize: {
                    xs: "12px",
                    sm: "20px",
                    md: "24px",
                  },
                  width: "100%",
                  color: "#000",
                  lineHeight: { xs: "26px", sm: "auto", md: "auto" },
                  fontFamily: "Poppins",
                  mb: {
                    xs: 1,
                    sm: 2,
                    md: 2,
                  },
                }}
              >
                {" "}
                Local Intelligence Engine
              </MDTypography>
              <MDTypography
                sx={{
                  fontWeight: "400",
                  fontSize: "18px",
                  width: "100%",
                  color: "#000",
                  fontFamily: "Poppins",
                  fontSize: {
                    xs: "10px",
                    sm: "14px",
                    md: "16px",
                  },
                  lineHeight: {
                    xs: 1.5,
                    sm: 2.2,
                    md: 2.2,
                  },
                  mb: {
                    xs: 0,
                    sm: 1,
                    md: 1,
                  },
                }}
              >
                {" "}
                TavloAI transforms neighborhood data into actionable guest
                insights.
              </MDTypography>

              <List>
                {itemOne.map((item, index) => (
                  <ListItem key={index} disableGutters alignItems="flex-start">
                    <MDBox
                      sx={{
                        marginLeft: { xs: "6px", sm: "15px", md: "15px" },
                        fontSize: { xs: "5px", sm: "6px", md: "6px" },
                        mr: 1,
                        lineHeight: 2.2,
                        mt: {
                          xs: "5px",
                          sm: "10px",
                          md: "15px",
                        },
                      }}
                    >
                      <FiberManualRecordIcon sx={{ color: "#000" }} />
                    </MDBox>
                    <ListItemText
                      primary={item}
                      primaryTypographyProps={{
                        sx: {
                          fontFamily: "urbanist",
                          fontWeight: 400,
                          fontSize: {
                            xs: "10px",
                            sm: "14px",
                            md: "16px",
                          },
                          color: "#000",
                          fontFamily: "Poppins",
                          lineHeight: {
                            xs: "18px",
                            sm: 2.2,
                            md: 2.2,
                          },
                        },
                      }}
                    />
                  </ListItem>
                ))}
              </List>
              <MDBox
                sx={{
                  display: "flex",
                  justifyContent: "flex-start",
                  width: "100%",
                  mt: {
                    xs: 1,
                    sm: 1,
                    md: 3,
                  },
                }}
              >
                <MDBox
                  component={NavLink}
                  to="/sign-up"
                  color="black"
                  sx={{
                    color: "#fff",
                    backgroundColor: "#000",
                    height: { xs: "29px", sm: "auto", md: "auto" },
                    padding: {
                      xs: "0px 20px",
                      sm: "12px 48px",
                      md: "20px 48px",
                    },
                    borderRadius: {
                      xs: "7px",
                      sm: "10px",
                      md: "10px",
                    },
                    fontSize: {
                      xs: "12px",
                      sm: "14px",
                      md: "15px",
                    },
                    fontWeight: 600,
                    lineHeight: {
                      xs: "30px",
                      sm: 0.6,
                      md: 0.6,
                    },
                    fontFamily: "Poppins",
                    textTransform: "none",
                    textTransform: "captialise",
                    "&:hover": {
                      backgroundColor: "#333",
                    },
                  }}
                >
                  Try Now
                </MDBox>
              </MDBox>
            </MDBox>
          </Grid>

          <Grid
            item
            xs={5}
            lg={6}
            sx={{
              width: {
                xs: "100%",
                sm: "40%",
              },

              position: "relative",
            }}
          >
            <MDBox
              sx={{
                width: "100%",
                display: "flex",
                justifyContent: "end",
                alignItems: "end",
              }}
            >
              <MDBox
                sx={{
                  display: { xs: "none", sm: "block", md: "block" },
                  mt: {
                    xs: 6,
                    sm: -3,
                    md: -3,
                  },
                  width: {
                    xs: "100%",
                    sm: "95%",
                  },
                  height: {
                    xs: "390px",
                    sm: "657px",
                    md: "657px",
                  },
                  marginRight: {
                    xs: "-30px",
                    sm: "-150px",
                    md: "-150px",
                  },
                  transform: "rotate(0deg)",
                  opacity: 1,
                  borderRadius: "20px",
                  background:
                    "linear-gradient(90deg, #63A4EA 14.75%, #E6DADA 89.36%)",
                }}
              ></MDBox>

              <MDBox
                component="img"
                src={MobLocalI}
                alt="Woman using a laptop"
                sx={{
                  display: { xs: "block", sm: "none", md: "none" },
                  width: {
                    xs: "136px",
                    sm: "95%",
                  },
                  mt: {
                    xs: 4,
                    sm: -3,
                    md: -3,
                  },
                  height: {
                    xs: "329px",
                    sm: "657px",
                    md: "657px",
                  },
                  marginRight: {
                    xs: "-30px",
                    sm: "-150px",
                    md: "-150px",
                  },
                  maxWidth: "100%",
                  borderRadius: { xs: "0px", sm: "20px", md: "20px" },
                }}
              />
            </MDBox>

            <MDBox
              sx={{
                position: {
                  xs: "relative",
                  md: "absolute",
                },
                top: {
                  xs: -100,
                  md: 75,
                },
                right: {
                  xs: -17,
                  md: -40,
                },
                mt: {
                  xs: "-200px",
                  sm: "-230px",
                  md: 0,
                },
                pr: {
                  xs: 0,
                  md: "4rem",
                },
                display: "flex",
                justifyContent: "center",
              }}
            >
              <MDBox
                component="img"
                src={MobLocalII}
                alt="Woman using a laptop"
                sx={{
                  display: { xs: "block", sm: "none", md: "none" },
                  width: {
                    xs: "212px",
                    sm: "100%",
                    md: "100%",
                  },
                  maxWidth: "100%",
                  borderRadius: { xs: "0px", sm: "20px", md: "20px" },
                  height: {
                    xs: "251px", // Mobile height
                    sm: "260px", // Tablet height
                    md: "345px", // Desktop height
                  },
                }}
              />
            </MDBox>

            <MDBox
              sx={{
                display: { xs: "none", sm: "block", md: "block" },
                position: "absolute",
                zIndex: { xs: 2, sm: 0, md: 0 },
                top: {
                  xs: 60,
                  sm: 60,
                },
                left: {
                  xs: -10,
                  sm: 18,
                },
                pr: "0rem",
                "@media (min-width:992px)": { marginTop: "0px", pr: "4rem" },
                marginTop: "35px",
              }}
            >
              <img
                src={image6}
                alt="Woman using a laptop on her lap with a message on the screen"
                style={{
                  maxWidth: "60%",
                  height: {
                    xs: "200px",
                    sm: "200px",
                    md: "467px",
                  },
                  // border:"1px solid red",
                  display: "block",
                  borderRadius: "20px",
                }}
              />
            </MDBox>

            <MDBox
              sx={{
                display: { xs: "none", sm: "block", md: "block" },

                position: "absolute",
                // border: "1px solid red",
                bottom: {
                  xs: 50,
                  sm: 90,
                },
                left: {
                  xs: 50,
                  sm: 280,
                  md: 250,
                },
                width: {
                  xs: "100%",
                  sm: "100%",
                  md: "69%",
                },
                pr: "0rem",
                // border: "1px solid red",

                "@media (min-width:992px)": { marginTop: "0px", pr: "4rem" },
                marginTop: "35px",
              }}
            >
              <MDBox
                component="img"
                src={image7}
                alt="Woman using a laptop on her lap with a message on the screen"
                sx={{
                  // width: "100%",
                  width: {
                    xs: "277px", // mobile
                    sm: "100%", // tablet
                    md: "350px ", // medium and up
                  },
                  height: {
                    xs: "147px", // mobile
                    sm: "50%", // tablet
                    md: "280px", // medium and up
                  },
                  display: "block",
                  borderRadius: "20px",
                }}
              />
            </MDBox>
          </Grid>
        </MDBox>
      </Grid>

      {/* third  */}
      <Grid
        container
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          pb: 0,
          mb: 0,
          mt: 0,
          "@media(min-width:1024px)": { pb: 5, mb: 3 },
          "@media(min-width:1900px)": { paddingTop: "4rem", mt: 2, mb: 0 },
        }}
      >
        <MDBox
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            width: "100%",
            margin: "auto",
            // "@media (min-width:1580px)": { maxWidth: "1600px!important" },
          }}
        >
          <Grid
            item
            xs={4}
            lg={7}
            sx={{
              width: "100%",
              marginLeft: "-20px",
              position: "relative",
            }}
          >
            <MDBox
              sx={{
                display: {
                  xs: "none",
                  sm: "block",
                  md: "block",
                },
                position: "relative",
                bottom: -12,
                left: -80,

                width: {
                  xs: "100%",
                  sm: "87%",
                },
                pr: "200px",
                height: "44px",
                opacity: 1,
                borderRadius: "13px",
                background: "#FF981B",
              }}
            ></MDBox>
            <MDBox
              sx={{
                display: { xs: "none", sm: "block", md: "block" },
                mt: { xs: 4, sm: 2, md: 0 },
                width: { xs: "100%", sm: "93%", md: "93%" },
                height: { xs: "400px", sm: "450px", md: "563px" },
                transform: "rotate(0deg)",
                opacity: 1,
                borderRadius: "14px",
                background: "linear-gradient(90deg, #FFFFFF 0%, #FF981B 100%)",
              }}
            ></MDBox>
            <MDBox
              component="img"
              src={MobGradient}
              alt="Woman using a laptop"
              sx={{
                display: { xs: "block", sm: "none", md: "none" },
                width: {
                  xs: "166px", // mobile
                  sm: "85%",
                  md: "80%",
                },
                height: {
                  xs: "268px",
                  sm: "300px",
                  md: "567px",
                },
                maxWidth: "100%",
                borderRadius: { xs: "0px", sm: "20px", md: "20px" },
              }}
            />
            <MDBox
              sx={{
                position: "absolute",
                top: {
                  xs: -20,
                  sm: 90,
                },
                right: {
                  xs: 10,
                  sm: 70,
                },
                // right: 14,
                pr: "0rem",
                "@media (min-width:992px)": { marginTop: "0px", pr: "4rem" },
                marginTop: "35px",
              }}
            >
              <MDBox
                component="img"
                src={image8}
                alt=" laptop"
                sx={{
                  width: {
                    xs: "139px",
                    sm: "100%",
                    md: "100%",
                  },
                  maxWidth: "100%",
                  borderRadius: { xs: "0px", sm: "20px", md: "20px" },
                  height: {
                    xs: "192px", // Mobile height
                    sm: "300px", // Tablet height
                    md: "437px", // Desktop height
                  },
                }}
              />
            </MDBox>

            <MDBox
              sx={{
                position: "absolute",
                bottom: {
                  xs: 10,
                  sm: 0,
                  md: 0,
                },
                // right: 294,
                right: {
                  xs: 5,
                  sm: 340,
                  md: 340,
                },
                zIndex: 2,
                pr: "0rem",
                "@media (min-width:992px)": { marginTop: "0px", pr: "4rem" },
                marginTop: "35px",
              }}
            >
              <MDBox
                component="img"
                src={Group}
                alt=" laptop"
                sx={{
                  width: {
                    xs: "48px",
                    sm: "100%",
                    md: "100%",
                  },
                  maxWidth: "100%",
                  borderRadius: { xs: "0px", sm: "20px", md: "20px" },
                  height: {
                    xs: "42px", // Mobile height
                    sm: "177px", // Tablet height
                    md: "177px", // Desktop height
                  },
                }}
              />
            </MDBox>
          </Grid>

          <Grid
            item
            xs={8}
            lg={5}
            sx={{
              ml: { xs: 0, sm: 8, md: 5 },
              pt: { xs: 0, sm: 8, md: 8 },
            }}
          >
            <MDBox
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexDirection: "column",
                height: "100%",
                pr: { xs: 1, sm: 8, md: 0 },
                ml: { xs: 0, sm: 8, md: "-11%" },
                paddingLeft: "-40px",
                "@media(min-width:320px)": {
                  marginTop: "0px",
                  marginBottom: "26px",
                },
                "@media(min-width:576px)": { marginBottom: "0px" },
              }}
            >
              <MDTypography
                sx={{
                  fontWeight: "600",
                  fontSize: {
                    xs: "12px",
                    sm: "20px",
                    md: "24px",
                  },
                  width: "100%",
                  color: "#000",
                  fontFamily: "Poppins",
                  lineHeight: { xs: "26px", sm: "auto", md: "auto" },
                  mb: {
                    xs: 0,
                    sm: 2,
                    md: 2,
                  },
                  mt: {
                    xs: 2,
                    sm: 0,
                    md: 0,
                  },
                }}
              >
                {" "}
                Marketing & Business Intelligence
              </MDTypography>
              <MDTypography
                sx={{
                  fontWeight: "400",
                  fontSize: "18px",
                  width: "100%",
                  color: "#000",
                  fontFamily: "Poppins",
                  fontSize: {
                    xs: "10px",
                    sm: "14px",
                    md: "16px",
                  },
                  lineHeight: {
                    xs: 1.5,
                    sm: 2.2,
                    md: 2.2,
                  },
                  mb: {
                    xs: 0,
                    sm: 1,
                    md: 1,
                  },
                }}
              >
                {" "}
                TavloAI delivers powerful, real-time insights to drive smarter
                decisions and faster growth.
              </MDTypography>

              <List>
                {itemTwo.map((item, index) => (
                  <ListItem key={index} disableGutters alignItems="flex-start">
                    <MDBox
                      sx={{
                        marginLeft: { xs: "6px", sm: "15px", md: "15px" },
                        fontSize: { xs: "5px", sm: "6px", md: "6px" },
                        mr: 1,
                        lineHeight: 2.2,
                        mt: {
                          xs: "5px",
                          sm: "10px",
                          md: "15px",
                        },
                      }}
                    >
                      <FiberManualRecordIcon sx={{ color: "#000" }} />
                    </MDBox>
                    <ListItemText
                      primary={item}
                      primaryTypographyProps={{
                        sx: {
                          fontFamily: "urbanist",
                          fontWeight: 400,
                          fontSize: {
                            xs: "10px",
                            sm: "14px",
                            md: "16px",
                          },
                          color: "#000",
                          fontFamily: "Poppins",
                          lineHeight: {
                            xs: "18px",
                            sm: 2.2,
                            md: 2.2,
                          },
                        },
                      }}
                    />
                  </ListItem>
                ))}
              </List>
              <MDBox
                sx={{
                  display: "flex",
                  justifyContent: "flex-start",
                  width: "100%",
                  mt: {
                    xs: 1,
                    sm: 1,
                    md: 3,
                  },
                }}
              >
                <MDBox
                  component={NavLink}
                  to="/sign-up"
                  color="black"
                  sx={{
                    color: "#fff",
                    backgroundColor: "#000",
                    height: { xs: "29px", sm: "auto", md: "auto" },
                    padding: {
                      xs: "0px 20px",
                      sm: "12px 48px",
                      md: "20px 48px",
                    },
                    borderRadius: {
                      xs: "7px",
                      sm: "10px",
                      md: "10px",
                    },
                    fontSize: {
                      xs: "12px",
                      sm: "14px",
                      md: "15px",
                    },
                    fontWeight: 600,
                    lineHeight: {
                      xs: "30px",
                      sm: 0.6,
                      md: 0.6,
                    },
                    fontFamily: "Poppins",
                    textTransform: "none",
                    textTransform: "captialise",
                    "&:hover": {
                      backgroundColor: "#333",
                    },
                  }}
                >
                  Try Now
                </MDBox>
              </MDBox>
            </MDBox>
          </Grid>
        </MDBox>
      </Grid>

      {/* Fourth */}
      <Grid
        container
        sx={{
          display: "flex",
          alignItems: "start",
          justifyContent: "space-between",
          pb: 0,
          mb: 0,
          mt: 0,
          width: "100%",
          "@media(min-width:1024px)": { pb: 5, mb: 3 },
          "@media(min-width:1900px)": { paddingTop: "4rem", mt: 2, mb: 0 },
        }}
      >
        <MDBox
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            pt: { xs: 0, sm: 1, md: 3 },
            mb: { xs: 6, sm: 1, md: 3 },
            width: "92%",
            margin: "auto",

            // "@media (min-width:1580px)": { maxWidth: "1600px!important" },
          }}
        >
          <Grid
            item
            xs={8}
            lg={5}
            sx={{
              width: {
                xs: "100%",
                sm: "50%",
              },
            }}
          >
            <MDBox
              sx={{
                display: "flex",
                alignItems: "start",
                justifyContent: "center",
                flexDirection: "column",
                height: "100%",
                pl: { xs: 0, sm: 1, md: 3 },
                "@media(min-width:320px)": {
                  marginTop: "25px",
                  marginBottom: "26px",
                },
                "@media(min-width:576px)": { marginBottom: "0px" },
              }}
            >
              <MDTypography
                sx={{
                  fontWeight: "600",
                  fontSize: {
                    xs: "13px",
                    sm: "20px",
                    md: "25px",
                  },
                  width: "100%",
                  color: "#000",
                  fontFamily: "Poppins",
                  mb: {
                    xs: 1,
                    sm: 2,
                    md: 2,
                  },
                  lineHeight: { xs: "26px", sm: "auto", md: "auto" },
                }}
              >
                {" "}
                AI-Driven Guest Intelligence
              </MDTypography>
              <MDTypography
                sx={{
                  fontWeight: "400",
                  fontSize: "18px",
                  width: "100%",
                  color: "#000",
                  fontFamily: "Poppins",
                  fontSize: {
                    xs: "10px",
                    sm: "14px",
                    md: "16px",
                  },
                  lineHeight: {
                    xs: 1.5,
                    sm: 2.2,
                    md: 2.2,
                  },
                  mb: {
                    xs: 0,
                    sm: 1,
                    md: 1,
                  },
                }}
              >
                {" "}
                Engage local customers celebrating birthdays, anniversaries, and
                milestones—automatically.
              </MDTypography>

              <List alignItems="flex-start">
                {itemThree.map((item, index) => (
                  <ListItem key={index} disableGutters alignItems="flex-start">
                    <MDBox
                      sx={{
                        marginLeft: { xs: "6px", sm: "15px", md: "15px" },
                        fontSize: { xs: "5px", sm: "6px", md: "6px" },
                        mr: 1,
                        lineHeight: 2.2,
                        mt: {
                          xs: "5px",
                          sm: "10px",
                          md: "15px",
                        },
                      }}
                    >
                      <FiberManualRecordIcon sx={{ color: "#000" }} />
                    </MDBox>
                    <ListItemText
                      primary={item}
                      primaryTypographyProps={{
                        sx: {
                          fontFamily: "urbanist",
                          fontWeight: 400,
                          fontSize: {
                            xs: "10px",
                            sm: "14px",
                            md: "16px",
                          },
                          color: "#000",
                          fontFamily: "Poppins",
                          lineHeight: {
                            xs: "18px",
                            sm: 2.2,
                            md: 2.2,
                          },
                        },
                      }}
                    />
                  </ListItem>
                ))}
              </List>
              <MDBox
                sx={{
                  display: "flex",
                  justifyContent: "flex-start",
                  width: "100%",
                  mt: {
                    xs: 1,
                    sm: 1,
                    md: 3,
                  },
                }}
              >
                <MDBox
                  component={NavLink}
                  to="/sign-up"
                  color="black"
                  sx={{
                    color: "#fff",
                    backgroundColor: "#000",
                    height: { xs: "29px", sm: "auto", md: "auto" },
                    padding: {
                      xs: "0px 20px",
                      sm: "12px 48px",
                      md: "20px 48px",
                    },
                    borderRadius: {
                      xs: "7px",
                      sm: "10px",
                      md: "10px",
                    },
                    fontSize: {
                      xs: "12px",
                      sm: "14px",
                      md: "15px",
                    },
                    fontWeight: 600,
                    lineHeight: {
                      xs: "30px",
                      sm: 0.6,
                      md: 0.6,
                    },
                    fontFamily: "Poppins",
                    textTransform: "none",
                    textTransform: "captialise",
                    "&:hover": {
                      backgroundColor: "#333",
                    },
                  }}
                >
                  Try Now
                </MDBox>
              </MDBox>
            </MDBox>
          </Grid>

          <Grid
            item
            xs={4}
            lg={7}
            sx={{
              width: {
                xs: "100%",
                sm: "50%",
              },
              position: "relative",
            }}
          >
            <MDBox
              sx={{
                width: "100%",
                display: "flex",
                justifyContent: "end",
                alignItems: "end",
              }}
            >
              <MDBox
                sx={{
                  display: { xs: "none", sm: "block", md: "block" },
                  width: {
                    xs: "100%",
                    sm: "93%",
                  },
                  height: "627px",
                  transform: "rotate(0deg)",
                  marginRight: {
                    xs: "-150px",
                    sm: "-200px",
                  },
                  opacity: 1,
                  borderRadius: "20px",
                  background:
                    "linear-gradient(90deg, #63A4EA 14.75%, #E6DADA 89.36%)",
                }}
              ></MDBox>
              <MDBox
                component="img"
                src={MobLocalI}
                alt="Woman using a laptop"
                sx={{
                  display: { xs: "block", sm: "none", md: "none" },
                  width: {
                    xs: "136px",
                    sm: "95%",
                  },
                  mt: {
                    xs: 4,
                    sm: -3,
                    md: -3,
                  },
                  height: {
                    xs: "222px",
                    sm: "657px",
                    md: "657px",
                  },
                  marginRight: {
                    xs: "-30px",
                    sm: "-150px",
                    md: "-150px",
                  },
                  maxWidth: "100%",
                  borderRadius: { xs: "0px", sm: "20px", md: "20px" },
                }}
              />
            </MDBox>
            <MDBox
              sx={{
                position: "absolute",
                // top: 80,
                top: {
                  xs: 80,
                  sm: 80,
                },
                left: {
                  xs: 55,
                  sm: 45,
                },
                width: {
                  xs: "75%",
                  sm: "80%",
                  md: "540px",
                },

                // width: "65%",
                // border: "1px solid red",

                // left: 88,
                pr: "0rem",
                "@media (min-width:992px)": { marginTop: "0px", pr: "4rem" },
                marginTop: "35px",
              }}
            >
              {/* Desktop  */}
              <MDBox
                component="img"
                src={image11}
                alt="Woman using a laptop on her lap with a message on the screen"
                sx={{
                  display: { xs: "none", sm: "block", md: "block" },
                  // width: "100%",
                  width: {
                    xs: "176px", // mobile
                    sm: "100%", // tablet
                    md: "640px", // medium and up
                    // xl: "70%",
                  },
                  height: {
                    xs: "115px", // mobile
                    sm: "100%", // tablet
                    md: "330px", // medium and up
                  },
                  borderRadius: "20px",
                }}
              />

              {/* Mobile  */}
              <MDBox
                component="img"
                src={MobCutt}
                alt="Woman using a laptop on her lap with a message on the screen"
                sx={{
                  display: { xs: "block", sm: "none", md: "none" },
                  // width: "100%",
                  width: {
                    xs: "176px", // mobile
                    sm: "100%", // tablet
                    md: "640px", // medium and up
                    // xl: "70%",
                  },
                  height: {
                    xs: "115px", // mobile
                    sm: "100%", // tablet
                    md: "330px", // medium and up
                  },
                  borderRadius: {
                    xs: "10px", // mobile
                    sm: "20px", // tablet
                    md: "20px", // medium and up
                  },
                }}
              />
            </MDBox>

            <MDBox
              sx={{
                width: "100%",
                position: "relative",
                display: "flex",
                justifyContent: "center",
              }}
            >
              <MDBox
                sx={{
                  width: "100%",
                  maxWidth: "1920px",
                  position: "absolute",
                  bottom: {
                    xs: 130,
                    sm: 100,
                    md: "115px",
                  },
                  right: {
                    xs: 20,
                    sm: 0, // Keep inside container
                    md: "-295px",
                    // xl: "-30%",
                  },
                  px: 2, // padding for small screens
                }}
              >
                <MDBox
                  sx={{
                    width: {
                      xs: "100%",
                      sm: "100%",
                      md: "330px",
                    },

                    display: "flex",
                    justifyContent: "flex-end", // align image to the right inside max-width box
                  }}
                >
                  <MDBox
                    component="img"
                    src={composeAdorn}
                    alt="Woman using a laptop on her lap with a message on the screen"
                    sx={{
                      display: { xs: "block", sm: "none", md: "none" },
                      // width: "100%",
                      width: {
                        xs: "100px", // mobile
                        sm: "100%", // tablet
                        md: "70%", // medium and up
                        // xl: "70%",
                      },
                      height: {
                        xs: "79px", // mobile
                        sm: "100%", // tablet
                        md: "70%", // medium and up
                      },
                      display: "block",
                      borderRadius: {
                        xs: "10px", // mobile
                        sm: "20px", // tablet
                        md: "20px", // medium and up
                      },
                    }}
                  />
                </MDBox>
              </MDBox>
            </MDBox>
          </Grid>
        </MDBox>
      </Grid>

      {/* Fifth  */}

      <Grid container>
        <Grid
          item
          lg={12}
          sx={{
            background:
              "linear-gradient(180deg, rgba(113, 181, 254, 0.7) 4.33%, rgba(255, 255, 255, 0.7) 27.4%, rgba(255, 255, 255, 0.7) 42.31%, rgba(255, 255, 255, 0.7) 60.1%, rgba(255, 255, 255, 0.7) 65.38%, rgba(113, 181, 254, 0.7) 100%)",
            // py: 6,
            pt: { xs: 4, sm: 4, md: 10 },
          }}
        >
          <MDBox sx={{ width: "92%", margin: "auto" }}>
            <MDBox
              sx={{
                dislay: "flex ",
                justifyContent: "center",
                alignItems: "center",
                textAlign: "center",
              }}
            >
              <MDTypography
                sx={{
                  fontWeight: "400",
                  fontSize: {
                    xs: "10px",
                    sm: "14px",
                    md: "20px",
                  },
                  color: "#000",
                  fontFamily: "Poppins",
                }}
              >
                It’s not the end,
              </MDTypography>

              <MDTypography
                sx={{
                  display: { xs: "none", sm: "block", md: "block" },
                  fontWeight: "600",
                  fontSize: {
                    xs: "15px",
                    sm: "38px",
                    md: "38px",
                  },
                  marginBottom: {
                    xs: "18px",
                    sm: "0px",
                  },
                  color: "#000000",
                  fontFamily: "Poppins",
                  lineHeight: 1.2,
                  mb: 1,
                }}
              >
                Your AI-Powered Marketing <br></br> in Action
              </MDTypography>

              <MDTypography
                sx={{
                  display: { xs: "block", sm: "none", md: "none" },
                  fontWeight: "600",
                  fontSize: {
                    xs: "17px",
                    sm: "38px",
                    md: "38px",
                  },
                  marginBottom: {
                    xs: "18px",
                    sm: "0px",
                  },
                  color: "#000000",
                  fontFamily: "Poppins",
                  lineHeight: 1.2,
                  mb: 1,
                }}
              >
                Your AI-Powered Marketing in Action
              </MDTypography>
            </MDBox>
            <Grid
              sx={{
                display: "flex",
                justifyContent: {
                  xs: "start",
                  sm: "space-between",
                  smd: "space-between",
                },
                alignItems: "center",
                flexDirection: {
                  xs: "column",
                  sm: "row",
                },
                height: { xs: "350px", sm: "500px", md: "500px" },
              }}
            >
              <Grid item lg={7}>
                <MDBox
                  sx={{ width: { xs: "100%", sm: "85%", md: "85%" }, pl: 2 }}
                >
                  <MDTypography
                    sx={{
                      fontWeight: "400",
                      fontSize: "18px",
                      width: "100%",
                      mb: 2,
                      color: "#000",
                      fontFamily: "Poppins",
                      fontSize: {
                        xs: "12px",
                        sm: "14px",
                        md: "16px",
                      },
                      lineHeight: {
                        xs: 1.5,
                        sm: 1.5,
                        md: 1.7,
                      },
                      mb: {
                        xs: 0,
                        sm: 1,
                        md: 1,
                      },
                    }}
                  >
                    {" "}
                    TavloAI offers end-to-end marketing support to turn insights
                    into real-world results, including:
                  </MDTypography>
                  <List sx={{ mb: { xs: 0, sm: 1, md: 2 } }}>
                    {itemFour.map((item, index) => (
                      <ListItem
                        key={index}
                        disableGutters
                        alignItems="flex-start"
                      >
                        <MDBox
                          sx={{
                            marginLeft: { xs: "0px", sm: "15px", md: "15px" },
                            fontSize: "6px",
                            mr: 1,
                            lineHeight: 2.2,
                            mt: {
                              xs: "5px",
                              sm: "10px",
                              md: "15px",
                            },
                          }}
                        >
                          <FiberManualRecordIcon sx={{ color: "#000" }} />
                        </MDBox>
                        <ListItemText
                          primary={item}
                          primaryTypographyProps={{
                            sx: {
                              fontFamily: "urbanist",
                              fontWeight: 400,
                              fontSize: {
                                xs: "10px",
                                sm: "14px",
                                md: "16px",
                              },
                              color: "#000",
                              fontFamily: "Poppins",
                              lineHeight: {
                                xs: 2.1,
                                sm: 2.2,
                                md: 2.2,
                              },
                            },
                          }}
                        />
                      </ListItem>
                    ))}
                  </List>
                  <MDTypography
                    sx={{
                      display: { xs: "none", sm: "block", md: "block" },
                      fontWeight: "400",
                      width: { xs: "60%", sm: "50%", md: "100%" },
                      color: "#000",
                      fontFamily: "Poppins",
                      fontSize: {
                        xs: "10px",
                        sm: "14px",
                        md: "16px",
                      },
                      lineHeight: {
                        xs: 1.5,
                        sm: 1.5,
                        md: 1.5,
                      },
                      mb: {
                        xs: 0,
                        sm: 1,
                        md: 1,
                      },
                    }}
                  >
                    {" "}
                    We blend smart technology with human expertise, so your
                    restaurant has a full-service marketing team at your
                    disposal.
                  </MDTypography>

                  <MDBox
                    sx={{
                      display: { xs: "none", sm: "flex", md: "flex" },
                      // display: "flex",
                      justifyContent: "flex-start",
                      width: "100%",
                      mt: {
                        xs: 1,
                        sm: 1,
                        md: 3,
                      },
                    }}
                  >
                    <MDBox
                      component={NavLink}
                      to="/contact"
                      sx={{
                        display: "inline-block",
                        color: "#fff",
                        backgroundColor: "#000",
                        padding: {
                          xs: "2px 28px",
                          sm: "12px 48px",
                          md: "20px 48px",
                        },
                        borderRadius: {
                          xs: "7px",
                          sm: "10px",
                          md: "10px",
                        },
                        fontSize: {
                          xs: "12px",
                          sm: "14px",
                          md: "15px",
                        },
                        fontWeight: 600,
                        lineHeight: 0.6,
                        fontFamily: "Poppins",
                        textTransform: "capitalize",
                        textDecoration: "none",
                        textAlign: "center",
                        "&:hover": {
                          backgroundColor: "#333",
                        },
                      }}
                    >
                      Contact Us
                    </MDBox>
                  </MDBox>
                </MDBox>
              </Grid>
              <Grid
                item
                lg={5}
                sx={{
                  display: "flex",
                  justifyContent: "between",
                  alignItems: "start",
                }}
              >
                <MDBox>
                  <MDTypography
                    sx={{
                      display: { xs: "blcok", sm: "none", md: "none" },
                      fontWeight: "400",
                      width: { xs: "90%", sm: "50%", md: "100%" },
                      color: "#000",
                      fontFamily: "Poppins",
                      fontSize: {
                        xs: "10px",
                        sm: "14px",
                        md: "16px",
                      },
                      lineHeight: {
                        xs: 1.5,
                        sm: 1.5,
                        md: 1.5,
                      },
                      mb: {
                        xs: 0,
                        sm: 1,
                        md: 1,
                      },
                      pt: {
                        xs: 1,
                        sm: 0,
                        md: 0,
                      },
                      marginLeft: { xs: "15px", sm: "0px", md: "0px" },
                    }}
                  >
                    {" "}
                    We blend smart technology with human expertise, so your
                    restaurant has a full-service marketing team at your
                    disposal.
                  </MDTypography>

                  <MDBox
                    sx={{
                      display: { xs: "block", sm: "none", md: "none" },
                      // display: "flex",
                      justifyContent: "flex-start",
                      width: "100%",
                      marginLeft: { xs: "15px", sm: "0px", md: "0px" },
                      mt: {
                        xs: 1,
                        sm: 1,
                        md: 3,
                      },
                    }}
                  >
                    <MDBox
                      component={NavLink}
                      to="/contact"
                      color="black"
                      sx={{
                        width: "fit-content",
                        color: "#fff",
                        backgroundColor: "#000",
                        height: { xs: "29px", sm: "auto", md: "auto" },
                        padding: {
                          xs: "7px 20px",
                          sm: "12px 48px",
                          md: "20px 48px",
                        },
                        borderRadius: {
                          xs: "7px",
                          sm: "10px",
                          md: "10px",
                        },
                        fontSize: {
                          xs: "12px",
                          sm: "14px",
                          md: "15px",
                        },
                        fontWeight: 600,
                        lineHeight: {
                          xs: "30px",
                          sm: 0.6,
                          md: 0.6,
                        },
                        fontFamily: "Poppins",
                        textTransform: "none",
                        textTransform: "captialise",
                        "&:hover": {
                          backgroundColor: "#333",
                        },
                      }}
                    >
                      Contact us
                    </MDBox>
                  </MDBox>
                </MDBox>

                <MDBox
                  component="img"
                  src={Contact}
                  alt="Woman"
                  sx={{
                    mb: { xs: 4, sm: 0, md: 0 },
                    width: "100%",
                    height: { xs: "170px", sm: "397px", md: "100%" },
                    // height: "100%",
                    objectFit: "cover",
                    borderRadius: "8px",
                  }}
                />
              </Grid>
            </Grid>
          </MDBox>
        </Grid>
      </Grid>

      {/* Sixth */}
      <MDBox sx={{ width: "88%", margin: "auto" }}>
        <Grid item lg={12} sx={{ my: { xs: 3, sm: 5, md: 5 } }}>
          <MDBox
            sx={{
              dislay: "flex ",
              justifyContent: "center",
              alignItems: "center",
              textAlign: "center",
              mb: { xs: 3, sm: 1, md: 7 },
            }}
          >
            <MDTypography
              sx={{
                fontWeight: "600",
                fontSize: {
                  xs: "21px",
                  sm: "38px",
                  md: "38px",
                },
                color: "#000",
                color: "#000000",
                fontFamily: "Poppins",
                lineHeight: 1.4,
                mb: { xs: 0, sm: 1, md: 1 },
              }}
            >
              Insights
            </MDTypography>
          </MDBox>

          <MDBox
            sx={{
              display: "flex",
              flexWrap: "wrap",
              gap: { xs: 3, sm: 4, md: 8 },
              justifyContent: "space-evenly",
              alignItems: "start",
            }}
          >
            {cardList.map((item, index) => (
              <MDBox
                key={index}
                sx={{
                  width: {
                    xs: "100%", // full width on small screens
                    sm: "48%", // half width on small-medium
                    md: "29%", // same for medium
                  },
                }}
              >
                <Card
                  sx={{
                    borderRadius: "20px",
                    boxShadow: "3px 6px 20px 3px #00000066",
                    overflow: "hidden",
                    height: "100%",
                  }}
                >
                  <MDBox
                    component="img"
                    src={item.image}
                    alt={item.title}
                    sx={{
                      borderRadius: { xs: "30px", sm: "20px", md: "0px" },
                      padding: { xs: 2, sm: 2, md: 0 },
                      width: "100%",
                      // objectFit: "cover",
                    }}
                  />
                  <CardContent sx={{ px: 4 }}>
                    <MDTypography
                      variant="subtitle2"
                      sx={{
                        color: "#F47C00",
                        fontWeight: 600,
                        display: "flex",
                        alignItems: "center",
                        gap: 1,
                        fontFamily: "Poppins",
                        fontSize: "12px",
                        mb: 0.5,
                      }}
                    >
                      {item.heading}
                    </MDTypography>
                    <NavLink to={item.link}>
                      <MDTypography
                        variant="subtitle2"
                        sx={{
                          width: { xs: "100%", sm: "90%", md: "95%" },
                          color: "#000",
                          fontWeight: 700,
                          gap: 1,
                          fontFamily: "Poppins",
                          fontSize: { xs: "14px", sm: "18px", md: "16px" },
                          height: "48px",
                          lineHeight: 1.2,
                        }}
                      >
                        {item.title}
                        
                          <ArrowOutwardIcon
                            sx={{ ml: 1, fontSize: "40px", color: "#F47C00" }}
                          />
                      </MDTypography>
                    </NavLink>
                    <MDTypography
                      variant="body2"
                      color="text.secondary"
                      sx={{
                        mb: {
                          xs: 0,
                          sm: 3,
                          md: 5,
                        },
                        fontFamily: "Poppins",
                        fontSize: { xs: "10px", sm: "15px", md: "13px" },
                        height: { xs: "auto", sm: "50px", md: "50px" },
                        fontWeight: 400,
                        lineHeight: { xs: "17px", sm: 1.3, md: 1.3 },
                      }}
                    >
                      {item.description}
                    </MDTypography>
                    <MDTypography variant="caption" color="text.secondary">
                      <MDButton
                        type="submit"
                        variant="contained"
                        color="black"
                        sx={{
                          display: { xs: "none", sm: "block", md: "block" },
                          mb: 2,
                          backgroundColor: "#318BEC",
                          color: "#fff",
                          borderRadius: "8px",
                          textTransform: "none",
                          fontWeight: 300,
                          fontSize: "12px",
                          height: "30px",
                          minHeight: "33px",
                          padding: "0 13px",
                          fontFamily: "Poppins",
                          "&:hover": {
                            backgroundColor: "#318BEC",
                          },
                        }}
                      >
                        <NavLink
                           to={item.link}
                          style={{
                            color: "#fff",
                            textDecoration: "none",
                            display: "inline-block",
                            fontSize: "12px",
                            fontFamily: "Poppins",

                            // width: "100%",
                            // height: "100%",
                          }}
                        >
                          Read More
                        </NavLink>
                      </MDButton>
                    </MDTypography>
                  </CardContent>
                </Card>
              </MDBox>
            ))}
          </MDBox>
        </Grid>
      </MDBox>

      {/* Seventh */}
      <Grid container>
        <Grid
          item
          lg={12}
          my={4}
          py={3}
          sx={{ width: "100%", backgroundColor: "#7CB1EB", color: "#fff" }}
        >
          <MDBox sx={{ width: "90%", margin: "auto" }}>
            <MDBox
              sx={{
                dislay: "flex ",
                justifyContent: "center",
                alignItems: "center",
                textAlign: "center",
                mb: 3,
              }}
            >
              <MDTypography
                sx={{
                  fontWeight: "600",
                  fontSize: "28px",
                  color: "#fff",
                  fontFamily: "Poppins",
                  fontSize: "25px",
                  lineHeight: 1,
                }}
              >
                Testimonials
              </MDTypography>
              <MDTypography
                sx={{
                  fontWeight: "400",
                  fontSize: "18px",
                  color: "#fff",
                  fontFamily: "Poppins",
                  fontSize: "11.5px",
                  lineHeight: 1.4,
                }}
              >
                See What restaurant owners say about TavloAI
              </MDTypography>
            </MDBox>

            <Testimonials />
          </MDBox>
        </Grid>
      </Grid>

      {/* Eighth */}
      <MDBox
        sx={{
          width: "90%",
          margin: "auto",
          mb: {
            xs: 2,
            sm: 3,
            md: 4,
          },
        }}
      >
        <Grid item lg={12} my={1}>
          <MDBox
            sx={{
              dislay: "flex ",
              justifyContent: "center",
              alignItems: "center",
              textAlign: "center",

              mb: {
                xs: 3,
                sm: 3,
                md: 6,
              },
            }}
          >
            <MDTypography
              sx={{
                fontWeight: "600",
                fontSize: "28px",
                color: "#000",
                fontFamily: "Poppins",
                fontSize: {
                  xs: "25px",
                  sm: "38px",
                  md: "2.4rem",
                },
                lineHeight: 1.4,
              }}
            >
              Numbers Tell The Truth
            </MDTypography>
          </MDBox>

          <MDBox
            sx={{
              backgroundColor: "#fff",
              boxShadow: "10px 10px 64px 0px #00000040",
              width: "100%",
              margin: "auto",
              borderRadius: {
                xs: "15px",
                sm: "20px",
                md: "30px",
              },
              padding: "10px",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              pb: {
                xs: 1,
                sm: 2,
                md: 4,
              },
            }}
          >
            {/* Left Box */}
            <MDBox
              sx={{
                width: "30%",
                pl: {
                  xs: 0,
                  sm: 2,
                  md: 2,
                },
                pr: {
                  xs: 0,
                  sm: 2,
                  md: 6,
                },
                my: 1,
                textAlign: "center",
              }}
            >
              <MDTypography
                variant="h2"
                sx={{
                  fontWeight: 900,
                  color: "#1A73E8",
                  fontFamily: "Poppins",
                  fontSize: {
                    xs: "22px",
                    sm: "3.2rem",
                  },
                  mb: {
                    xs: 0,
                    sm: 2,
                    md: 2,
                  },
                }}
              >
                97.4%
              </MDTypography>
              <MDTypography
                variant="body2"
                sx={{
                  color: "#000",
                  fontSize: {
                    xs: "11px",
                    sm: "1rem",
                    md: "1.2rem",
                  },
                  fontFamily: "Poppins",
                }}
              >
                Satisfaction Rate
              </MDTypography>
            </MDBox>
            <MDBox
              sx={{
                width: "1px ",
                backgroundColor: "white",
                height: {
                  xs: "50px",
                  sm: "70px",
                  md: "90px",
                },
                boxShadow: "2px 3px 3px 2px #0000001A",
              }}
            ></MDBox>
            {/* Center Box */}
            <MDBox
              sx={{
                width: "40%",
                px: 4,
                my: 1,
                textAlign: "center",
              }}
            >
              <MDTypography
                variant="h2"
                sx={{
                  fontWeight: 900,
                  color: "#1A73E8",
                  fontFamily: "Poppins",
                  fontSize: {
                    xs: "22px",
                    sm: "3.2rem",
                  },
                  mb: {
                    xs: 0,
                    sm: 2,
                    md: 2,
                  },
                }}
              >
                50%
              </MDTypography>
              <MDTypography
                variant="body2"
                sx={{
                  color: "#000",
                  fontSize: {
                    xs: "11px",
                    sm: "1.2rem",
                    md: "1.2rem",
                  },
                  fontFamily: "Poppins",
                  lineHeight: {
                    xs: 1,
                  },
                }}
              >
                Faster Review Responses
              </MDTypography>
            </MDBox>
            <MDBox
              sx={{
                width: "1px ",
                backgroundColor: "white",
                height: {
                  xs: "50px",
                  sm: "70px",
                  md: "90px",
                },
                boxShadow: "2px 3px 3px 2px #0000001A",
              }}
            ></MDBox>

            {/* Right Box */}
            <MDBox
              sx={{
                width: "30%",
                pl: {
                  xs: 1,
                  sm: 2,
                  md: 2,
                },
                pr: {
                  xs: 0,
                  sm: 2,
                  md: 6,
                },
                my: 1,
                textAlign: "center",
              }}
            >
              <MDTypography
                variant="h2"
                sx={{
                  fontWeight: 900,
                  color: "#1A73E8",
                  fontFamily: "Poppins",
                  fontSize: {
                    xs: "22px",
                    sm: "3.2rem",
                  },
                  mb: {
                    xs: 0,
                    sm: 2,
                    md: 2,
                  },
                }}
              >
                20%
              </MDTypography>
              <MDTypography
                variant="body2"
                sx={{
                  color: "#000",
                  fontSize: {
                    xs: "11px",
                    sm: "1.2rem",
                    md: "1.2rem",
                  },
                  fontFamily: "Poppins",
                }}
              >
                More Revenue
              </MDTypography>
            </MDBox>
          </MDBox>
        </Grid>
      </MDBox>

      {/* Ninth */}
      <Grid container>
        <Grid
          item
          lg={12}
          my={4}
          sx={{
            width: {
              xs: "100%",
              sm: "100%",
              md: "100%",
            },
            background:
              "linear-gradient(180deg, rgba(255, 255, 255, 0.6) 0%, rgba(49, 139, 236, 0.4) 51.67%, rgba(255, 255, 255, 0.6) 100%)",
            // height: "600px",
            height: {
              xs: "auto",
              sm: "600px",
            },
            mb: {
              xs: "0rem",
              sm: "2rem",
              md: "7rem",
            },
          }}
        >
          <Container>
            <MDBox
              sx={{
                dislay: "flex ",
                justifyContent: "center",
                alignItems: "center",
                textAlign: "center",
                mb: 2,
              }}
            >
              <MDTypography
                sx={{
                  mt: {
                    xs: 1,
                    sm: 2,
                    md: 3,
                  },
                  fontWeight: "600",
                  fontSize: {
                    xs: "25px",
                    sm: "25px",
                    md: " 28px",
                  },
                  color: "#000",
                  fontFamily: "Poppins",
                  lineHeight: 1.4,
                }}
              >
                One AI Dashboard
              </MDTypography>
            </MDBox>
            <MDBox
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                px: 2,
              }}
            >
              <MDBox
                sx={{
                  position: "relative",
                  mt: 0,
                  pt: 0,
                  borderRadius: "8px",
                  zIndex: 2,
                  mb: {
                    xs: 2,
                    sm: 4,
                    md: "72px",
                  },
                }}
              >
                {/* Main Image */}
                <MDBox
                  component="img"
                  src={Rectangle33}
                  alt="dashboard"
                  sx={{
                    maxWidth: "100%",
                    width: {
                      xs: "300px",
                      sm: "436px",
                      md: "100%",
                    },
                    height: {
                      xs: "240px",
                      sm: "436px",
                      md: "436px",
                    },
                  }}
                />

                <MDBox
                  sx={{
                    display: "flex",
                    gap: 4,
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  {/* Image Top Left */}
                  <MDBox
                    sx={{
                      position: "absolute",
                      top: { xs: 180, sm: 42, md: 42 },
                      left: {
                        xs: "39% !important",
                        sm: -165,
                        md: "-23% !important",
                      },
                      marginLeft: {
                        sm: 0,
                        xs: "-100px",
                      },

                      borderRadius: "8px",
                      zIndex: 2,
                      "@media(max-width:575px)": {
                        left: "50%",
                        transform: "translateX(-50%)",
                        mt: 2,
                      },
                    }}
                  >
                    <MDBox
                      component="img"
                      src={Group57}
                      alt="Woman"
                      sx={{
                        // border:"1px solid red",
                        maxWidth: "100%",
                        height: {
                          xs: "140px",
                          sm: "266px",
                          md: "266px",
                        },
                      }}
                    />
                  </MDBox>

                  {/* Image Bottom Left */}
                  <MDBox
                    sx={{
                      position: {
                        xs: "relative",
                        sm: "absolute",
                      },
                      bottom: { xs: 33, sm: -142 },
                      left: { xs: 170, sm: -145 },
                      marginLeft: {
                        sm: 0,
                        xs: " 70px",
                      },
                      borderRadius: "8px",
                      zIndex: 2,
                    }}
                  >
                    <MDBox
                      component="img"
                      src={Rectangle35}
                      alt="Woman using a laptop"
                      sx={{
                        maxWidth: "100%",
                        height: {
                          xs: "70px",
                          sm: "186px",
                          md: "186px",
                        },
                        // height: "186px",
                      }}
                    />
                  </MDBox>
                </MDBox>
                {/* Image Bottom Right */}
                <MDBox
                  sx={{
                    position: {
                      xs: "relative",
                      sm: "absolute",
                    },
                    display: {
                      xs: "none",
                      sm: "block",
                      md: "block",
                    },
                    bottom: { sm: -62 },
                    right: { sm: -220 },
                    borderRadius: "8px",
                    zIndex: 2,
                    "@media(max-width:575px)": {
                      left: "50%",
                      transform: "translateX(-50%)",
                      mt: 2,
                    },
                  }}
                >
                  <img
                    src={Group54}
                    alt="Bottom Right"
                    style={{ height: "136px", maxWidth: "100%" }}
                  />
                </MDBox>
              </MDBox>
            </MDBox>
          </Container>
        </Grid>
      </Grid>

      {/* tenth */}

      <Grid container>
        <Grid
          item
          lg={12}
          sx={{
            background:
              "linear-gradient(180deg, rgba(255, 255, 255, 0.6) 0%, rgba(49, 139, 236, 0.6) 100%)",
            py: { xs: 2, sm: 4, md: 12 },
            width: {
              xs: "100%",
              sm: "90%",
              md: "auto",
            },
            pb: {
              xs: 6,
              sm: 4,
              md: 6,
            },
          }}
        >
          <DemoRequestForm />
        </Grid>
      </Grid>

      {showButton && (
        <MDBox
          sx={{
            position: "fixed",
            bottom: bottomOffset,
            right: { xs: 20, md: 35 },
            zIndex: 9999,
          }}
        >
          <MDBox
            onClick={scrollToTop}
            sx={{
              cursor: "pointer",
              p: { xs: 0.5, md: 1 },
              backgroundColor: "#F47C00",
              borderRadius: "50%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              fontSize: "30px",
            }}
          >
            <ArrowUpwardIcon sx={{ color: "#fff", fontSize: "30px" }} />
          </MDBox>
        </MDBox>
      )}
    </MDBox>
  );
}

export default BodySection;
